import { useState } from 'react';
import { CustomAlert, Text } from '../../../../../../../shared/uiComponents';
import Content from './content';
import { EditIcon } from '../../../../../../../shared/Assets/svg';

const EditSteps = ({ id, programId }: { id: string; programId: string }) => {
	const [openEdit, setOpenEdit] = useState<boolean>(false);

	return (
		<>
			<div className="actionRow" onClick={() => setOpenEdit(true)}>
				<div className="actionIcon">
					<EditIcon />
				</div>
				<div className="actionContent">
					<Text title="Edit Steps" type="psm" fontWeight="medium" />
				</div>
			</div>
			<CustomAlert
				open={openEdit}
				onClose={() => setOpenEdit(false)}
				title="Steps"
				maxWidth="md"
				Content={({ onClose }) => <Content id={id} programId={programId} onClose={onClose} />}
			/>
		</>
	);
};

export default EditSteps;
